import { Client as TypesenseClient } from 'typesense'
import { CONNECTION_TIMEOUT_SECONDS, SEARCH_CACHE_SECONDS, type TypesenseSearchConfig } from './typesense'

/**
 * The Typesense client on its own module: the browser loads it (with axios) on the first search
 * (createTypesenseSearch in ./typesense.ts), the server spare part search uses it directly.
 */
export function createTypesenseClient(config: TypesenseSearchConfig, { cache = true } = {}) {
  return new TypesenseClient({
    // Copies: the client writes to the node objects, and runtimeConfig is frozen on the server
    ...(config.nearestNode && { nearestNode: { ...config.nearestNode } }),
    nodes: config.nodes.map(node => ({ ...node })),
    apiKey: config.apiKey,
    connectionTimeoutSeconds: CONNECTION_TIMEOUT_SECONDS,
    cacheSearchResultsForSeconds: cache ? SEARCH_CACHE_SECONDS : 0
  })
}
